// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-weight-classes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-weight-classes/aircraft-weight-classes.js';

mount([g0]);
